import api from "../api";

/**
 * Liste des proformas
 */
export const getProformas = async () => {
  const res = await api.get("/proformas");
  return res.data;
};

/**
 * Détail d'une proforma
 */
export const getProforma = async (id) => {
  const res = await api.get(`/proformas/${id}`);
  return res.data;
};

/**
 * Création
 */
export const createProforma = async (data) => {
  const res = await api.post("/proformas", data);
  return res.data;
};

/**
 * Modification
 */
export const updateProforma = async (id, data) => {
  const res = await api.put(`/proformas/${id}`, data);
  return res.data;
};

/**
 * Suppression logique
 */
export const deleteProforma = async (id) => {
  const res = await api.delete(`/proformas/${id}`);
  return res.data;
};

/**
 * Génération du PDF
 */
export const generatePdf = async (id) => {
  const res = await api.post(`/proformas/${id}/generate`);
  return res.data;
};

/**
 * Téléchargement
 */
export const getPdfUrl = (pdfPath) => {
  if (!pdfPath) return null;

  return `${window.location.origin}${pdfPath}`;
};